import { CheckoutPayload } from "@/checkout/types";
import { getCookie } from "@cappelendamm/cookie";

export function serializeCheckoutPayload(payload: CheckoutPayload): string {
  return JSON.stringify(payload);
}

function deserializeCheckoutPayload(payload: string): CheckoutPayload {
  return JSON.parse(payload);
}

export function generateCheckoutId(sku: string) {
  return btoa(`checkout-${sku}`);
}

/**
 * Retrieves the checkout session from the session storage based on the base64 encoded "checkoutId"
 */
export const getCheckoutPayloadFromCheckoutId = (
  checkoutId: string,
): CheckoutPayload | null => {
  const payload = getCookie(checkoutId);
  if (!payload) return null;
  return deserializeCheckoutPayload(payload);
};

/**
 * Retrieves the checkout session from the session storage based on the sku
 */
export const getCheckoutPayloadFromSku = (
  sku: string,
): CheckoutPayload | null => {
  const checkoutId = generateCheckoutId(sku);
  return getCheckoutPayloadFromCheckoutId(checkoutId);
};

/**
 * Clears the checkout session based on the base64 encoded "checkoutId"
 */
export const clearCheckoutSession = (checkoutId: string): void => {
  const sessionKey = atob(checkoutId);
  sessionStorage.removeItem(sessionKey);
};
